import { Navigate, Outlet } from "@tanstack/react-router";

import { useCreditBilling } from "../lib/billing";
import { InlineError, Skeleton, ToastProvider } from "../ui";
import { CheckoutOrb } from "./CheckoutOrb";

export function CheckoutLayout() {
  const capability = useCreditBilling();
  if (capability.isError) {
    return (
      <InlineError>Unable to load your account. Reload to retry.</InlineError>
    );
  }
  if (capability.isPending) {
    return <Skeleton shape="detail-field" label="Loading checkout" rows={4} />;
  }
  if (!capability.enabled) return <Navigate replace to="/" />;
  return (
    <ToastProvider>
      <div className="marker-theme-light marker-checkout-layout">
        <main className="marker-checkout-pane">
          <header className="marker-checkout-header">
            <div className="marker-checkout-wordmark">
              <img
                alt=""
                src="/brand/marker-app-favicon-light.svg"
                width="32"
                height="32"
              />
              <span>Marker</span>
            </div>
            <form action="/auth/logout" method="post">
              <button className="marker-checkout-text-link" type="submit">
                Sign out
              </button>
            </form>
          </header>
          <div className="marker-checkout-content">
            <Outlet />
          </div>
          <footer className="marker-checkout-footer">
            <a href="https://usemarker.ai/terms">Terms</a>
            <span aria-hidden="true">·</span>
            <a href="https://usemarker.ai/privacy">Privacy</a>
          </footer>
        </main>
        <aside className="marker-checkout-brand" aria-hidden="true">
          <CheckoutOrb />
          <p>Evals for production agents.</p>
        </aside>
      </div>
    </ToastProvider>
  );
}
